import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { PERSONALIZED_FOI_V2_250114 } from "@faire/web-api--source/indigofair/settings/PERSONALIZED_FOI_V2_250114";

export const useSettingPersonalizedFoiV2 = (): boolean => {
  return useSetting(PERSONALIZED_FOI_V2_250114, false);
};
